import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { EntradaEditarComponent } from './entrada-editar.component';


@NgModule({
    imports: [RouterModule.forChild([
        { path: ':id', component: EntradaEditarComponent }
    ])],
    exports: [RouterModule]
})
export class EntradaEditarRoutingModule { }
